export const NAVIGATION_VIEWPORT_BREAKPOINTS = {
    xxs: 0,
    xs: 350,
    sm: 375,
    md: 600,
    lg: 1200,
    xl: 1320,
    xxl: 1360,
    xxxl: 1400,
};
export const NAVIGATION_MAX_WIDTH = 1920;
